export const itTranslation = {
  header: {
    homeProjectors: "Proiettori domestici",
    portableProjectors: "Proiettori portatili",
    support: "Supporto",
    promotion: "Promozione",
    dropdownHome: "Modelli di proiettori domestici e accessori",
    dropdownPortable: "Modelli di proiettori portatili e power bank",
    dropdownSupport: "FAQ, manuali e informazioni di contatto",
  },
  main: {
    fastSelfHelpSupport: "Supporto rapido fai-da-te",
    card1: {
      title: "Domande pre-vendita",
      description: "Come acquistare con un grande sconto?",
      link: "Saperne di più",
    },
    card2: {
      title: "Supporto prodotto",
      description: "Hai problemi a usare il proiettore?",
      link: "Seleziona il tuo modello",
    },
    card3: {
      title: "Servizio post-vendita",
      description: "Garanzia, politica di restituzione e cambio",
      link: "Saperne di più",
    },
    getSupport: {
      title: "Ottieni supporto da noi",
      replyTime: "Di solito rispondiamo entro 1 giorno lavorativo.",
      checkFaq:
        "Per problemi con il dispositivo, si prega di controllare prima il {faqLink}",
    },
  },
  form: {
    name: "Nome",
    email: "E-mail",
    order_id: "Il tuo numero d'ordine",
    orderNumberHelp: "Come trovare il mio numero d'ordine?",
    describeIssue: "Si prega di descrivere il problema",
    descriptionHelp:
      "Si prega di fornire quante più foto e video possibili del guasto in modo da poter determinare rapidamente la soluzione.",
    fileUpload: "Caricamento file",
    fileUploadInstructions: "{action} i file in quest'area per caricarli.",
    fileUploadInstructionsAction: "Fai clic o trascina",
    fileUploadLimit: "Puoi caricare fino a 5 file.",
    filesSelected: "{{count}}/5 file selezionati.",
    maxFilesError: "Puoi caricare un massimo di 5 file.",
    surveyTitle:
      "Un piccolo sondaggio - Quali aggiornamenti vorresti per il tuo prossimo proiettore?",
    surveyPlaceholder: "es: voglio che sia più luminoso, più potente, ecc.",
    submit: "Invia",
    nextButton: "Avanti",
    previousButton: "Indietro",
    submitSuccess: "Ticket di supporto inviato! Ti risponderemo presto.",
    step2: {
      expectation: {
        label: "Soddisfa le tue aspettative?",
        optionYes: "Sì, funziona bene",
        optionNo: "No, ha problemi",
      },
      rating: {
        label: "Come lo valuteresti?",
      },
      features: {
        label:
          "Un piccolo sondaggio - Quali caratteristiche dei nostri prodotti ti attraggono di più?",
        placeholder:
          "Ad esempio: aspetto, prezzo accessibile, design unico, ecc.",
      },
    },
    step3: {
      title: "Richiedi il tuo regalo di attivazione! È gratis!",
      gift1Title: "1 anno di garanzia extra",
      gift2Title: "Sostituzione gratuita per 180 giorni",
      confirmation:
        "Invieremo un'email di conferma alla tua casella di posta, ti preghiamo di confermare la ricezione nell'email.",
      activateButton: "Attiva ora",
    },
    step4: {
      title: "Hai attivato con successo la tua garanzia!",
      line1:
        "Spero che ti piaccia il regalo di attivazione che abbiamo preparato per te.",
      line2:
        "Hai ricevuto un'email di conferma. Controlla la tua casella di posta per confermare i vantaggi selezionati.",
      line3: "Se non riesci a trovarla, controlla la cartella dello spam.",
    },
    errors: {
      nameRequired: "Il nome è obbligatorio.",
      emailRequired: "L'e-mail è obbligatoria.",
      emailInvalid: "L'e-mail non è valida.",
      order_idRequired: "Il numero d'ordine è obbligatorio.",
      order_idInvalid:
        "Formato del numero d'ordine non valido (es. XXX-XXXXXXX-XXXXXXX).",
      commentRequired: "Si prega di descrivere il problema.",
      filesRequired: "È richiesto almeno un file.",
      surveyRequired: "Il campo del sondaggio è obbligatorio.",
      expectationRequired: "Si prega di selezionare un'opzione.",
      ratingRequired: "Si prega di fornire una valutazione.",
      featuresRequired: "Questo campo del sondaggio è obbligatorio.",
      giftRequired: "Si prega di selezionare un regalo da attivare.",
    },
  },
  footer: {
    newsletterTitle: "Iscriviti alla nostra newsletter",
    newsletterDescription:
      "Iscriviti alla nostra newsletter per ricevere notizie personalizzate sui prodotti, aggiornamenti e inviti speciali",
    emailPlaceholder: "Indirizzo e-mail",
    signUp: "Iscriviti",
    products: "Prodotti",
    support: "Supporto",
    contactUs: "Contattaci",
    preSales: "Domande pre-vendita",
    productSupport: "Supporto prodotto",
    afterSales: "Servizio post-vendita",
    contactInfo: "Info contatto",
    workingHours: "(CST): Lun-Dom 9:00-19:00",
  },
};
